import { takeEvery } from 'redux-saga/effects';
import { fetchFilters } from './fetch-filters';
import { fetchAutocompleteOptions } from './fetch-autocomplete-options';

export function* fetchFiltersSaga() {
  yield takeEvery(['FETCH_FILTERS'], fetchFilters);
}

export function* fetchAutocompleteOptionsSaga() {
  yield takeEvery(['FETCH_AUTOCOMPLETE_OPTIONS'], fetchAutocompleteOptions);
}
